<template>
  <div class="page" v-loading="listLoading">
    <el-form @submit.native.prevent label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="供应商">
            <el-select v-model="searchData.SourceId" filterable remote placeholder="请选择 / 可搜索"
              :remote-method="querySupplier" style="width:100%">
              <el-option v-for="item in supplier" :key="item.id" :label="item.proSupplierName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品SpuId">
            <el-input v-model="searchData.ProductIds" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="规格编码">
            <el-input v-model="searchData.speCode" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品名称">
            <el-input v-model="searchData.ProductName" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="商品SkuId">
            <el-input v-model="searchData.ProductSkuIds" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品品牌">
            <el-autocomplete v-model="brandName" clearable :fetch-suggestions="querySearchAsync" placeholder="请选择"
              class="w100" @select="handleSelect"></el-autocomplete>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品型号">
            <el-input v-model="searchData.ProductModel" clearable placeholder="请输入"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="商品类型">
            <el-cascader v-model="searchData.CategoryIds" clearable :props="{ emitPath: false, checkStrictly: true }"
              class="w100" :show-all-levels="false" :options="productNavTypeTreeList" placeholder="请选择">
            </el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="创建时间">
            <el-date-picker v-model="valueTime" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handlePicker" class="w100">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
      </el-row>
      <el-form-item>
        <div class="flex">
          <el-button type="primary" @click="searchFun">查询</el-button>
          <el-button @click="resetFun">重置</el-button>
          <toolbar class="mgl10" :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
        </div>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table :data="tableList" highlight-current-row element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" style="width: 100%"
      border @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="50" fixed align="center"></el-table-column>
      <el-table-column prop="productId" label="SpuId" width="100" align="center"></el-table-column>
      <el-table-column prop="id" label="SkuId" width="100" align="center"></el-table-column>
      <el-table-column prop="speCode" label="规格编码" width="200" align="center"></el-table-column>
      <el-table-column label="平台库" width="200" align="center">
        <template slot-scope="scope">
          {{ scope.row.platformType === 1 ? "开普勒" : "" }} / {{ scope.row.platformCode }}
        </template>
      </el-table-column>
      <el-table-column label="分销商名称" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <p v-for="(item, index) in scope.row.saleSkuInfos" :key="index">{{ item.resellerName }}</p>
        </template>
      </el-table-column>
      <el-table-column label="商品图片" width="150" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.pictureUrl" width="120" alt="暂无" @click="handleLookBigPic(scope.row.pictureUrl)" />
        </template>
      </el-table-column>
      <el-table-column prop="productName" label="商品名称" align="center" min-width="300"></el-table-column>
      <el-table-column prop="productSpecExt" label="商品规格" align="center" width="120">
        <template slot-scope="scope">
          {{ scope.row.productSpecExt ? scope.row.productSpecExt : scope.row.productSpec}}
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" label="商品类型" align="center" width="120"></el-table-column>
      <el-table-column prop="brandName" label="商品品牌" width="120" align="center"></el-table-column>
      <el-table-column prop="productModel" label="商品型号" width="120" align="center"></el-table-column>
      <el-table-column label="查看" width="120" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="inventoryDetail(scope.row)">库存详情</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="stock" label="库存总量" width="100" align="center"></el-table-column>
      <el-table-column prop="costPrice" label="成本价" width="120" align="center"></el-table-column>
      <el-table-column prop="creationTime" label="创建时间" width="200" align="center"></el-table-column>
      <el-table-column prop="lastModificationTime" label="最近操作时间" width="200" align="center"></el-table-column>
      <el-table-column v-if="buttonList_table.length > 0" label="操作" fixed="right" align="center" width="300">
        <template slot-scope="scope">
          <el-button size="mini" 
          v-for="(item, index) in buttonList_table.filter(i=>i.buttonFunc!='handleOnShelve'&&i.buttonFunc!='handleOffShelve')" 
          :key="index" :type="item.buttonType"
          @click="callFunctionRow(item, index, scope.row)">{{ item.displayName }}</el-button>
          <el-button size="mini" 
          v-if="buttonList_table.filter(i=>i.buttonFunc=='handleOnShelve').length&&!scope.row.isShelves" 
          type="primary"
          @click="handleShelve(scope.row)">上架</el-button>
          <el-button size="mini" 
          v-if="buttonList_table.filter(i=>i.buttonFunc=='handleOffShelve').length&&scope.row.isShelves" 
          type="default"
          @click="handleShelve(scope.row)">下架</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :total="total" :page-sizes="[10, 20, 30, 40, 50, 100]">
    </el-pagination>
    <el-dialog width="50%" :visible.sync="isShowBigPic">
      <img :src="bigPic" style="width: 100%; height:100%;">
    </el-dialog>
    <!-- 库存详情 -->
    <el-dialog title="库存详情" :visible.sync="dialogInventory">
      <el-form :inline="true">
        <el-form-item label="仓库名:">
          <el-input size="small" v-model="searchInventory.WarehouseName" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="仓级筛选:">
          <el-select v-model="searchInventory.WarehouseLevel" clearable>
            <el-option label="全部" :value="null"></el-option>
            <el-option label="一级" :value="1"></el-option>
            <el-option label="二级" :value="2"></el-option>
            <el-option label="三级" :value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="search">查询</el-button>
          <el-button size="small" @click="empty">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="inventoryList" highlight-current-row border>
        <el-table-column prop="warehouseId" label="仓库ID" min-width="100" align="center"></el-table-column>
        <el-table-column prop="warehouseName" label="仓库名" min-width="100" align="center"></el-table-column>
        <el-table-column prop="warehouseLevel" label="仓级" min-width="150" align="center"></el-table-column>
        <el-table-column prop="warehouseSpace" label="仓位" min-width="150" align="center"></el-table-column>
        <el-table-column prop="warehouseDeliveryArea" label="发货区域" min-width="150" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.warehouseDeliveryArea">{{ scope.row.warehouseDeliveryArea }}</span>
            <el-button size="mini" type="text" @click="lookBtn(scope.row)" v-else>查看</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="stock" label="库存量" min-width="150" align="center"></el-table-column>
      </el-table>
      <el-pagination layout="total, sizes, prev, pager, next, jumper" class="pagination" :total="inventoryTotal"
        :current-page="searchInventory.PageIndex" :pageSize="searchInventory.PageSize"
        @current-change="handleInventoryCurrentChange" @size-change="handleInventorySizeChange"></el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../../util/date";
import {
  GetProductSkuList,
  CategoryGetTree,
  brandGetAll,
  ProductSkuDelete,
  GetAllInventoryItems,
  GetDeliveryAreas,
  ProductSkuExport,
  SupplierGetAll,
  ProductSkuShelves
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
import Toolbar from "../../../components/Toolbar";

export default {
  name: "skuList",
  components: { Toolbar },
  data() {
    return {
      dialogInventory: false,
      searchData: {
        speCode: null,
        ProductSkuIds: null,
        ProductIds: null,
        ProductName: null,
        CategoryIds: null,
        BrandIds: null,
        ProductModel: null,
        BeginCreationTime: null,
        EndCreationTime: null,
        SkipCount: 0,
        MaxResultCount: 10,
        SourceId: ""
      },
      PageIndex: 1, //页码
      PageSize: 10, //页长
      buttonList_table: [],
      buttonList_toolBar: [],
      productNavTypeTreeList: [],
      tableList: [],
      total: 0,
      listLoading: false,
      brandName: '',
      valueTime: [],
      restaurants: [],
      inputValue: "",
      IsShowPosition: 0,
      codeVisible: false,
      bigPic: null,
      isShowBigPic: false,
      searchInventory: {
        WarehouseName: null,
        WarehouseLevel: null,
        PageIndex: 1,
        PageSize: 10
      },
      inventoryTotal: 0,
      inventoryList: [],
      checkList: [],
      productSkuId: null,
      supplier: [],
    };
  },
  created() {
    this.getProductNavTypeTree();
    this.getBrandList();
    this.querySupplier()
  },
  mounted() {
    this.getSkuList();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    var buttonList = getButtonList(this.$route.path, routers);
    if (buttonList && buttonList.length > 0) {
      const toolBarButtonList = buttonList.filter((item) => {
        return item.buttonShow === 10;
      });
      this.buttonList_toolBar = toolBarButtonList;
      const tableButtonList = buttonList.filter((item) => {
        return item.buttonShow === 20;
      });
      this.buttonList_table = tableButtonList;
    }
  },
  methods: {
    exportBtn() {
      this.searchData.SkipCount = (this.PageIndex - 1) * this.PageSize
      this.searchData.MaxResultCount = this.PageSize
      ProductSkuExport(this.searchData).then(res => {
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' }) // res就是接口返回的文件流了
        let objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.download = 'sku列表.xlsx'  //后缀名一定要写对，不然会导致文件损坏，打不开
        a.href = objectUrl
        a.click()
        a.remove()
        console.log(res, '???????????')
      })
    },
    lookBtn(row) {
      GetDeliveryAreas({ WarehouseId: row.warehouseId, MaxLevel: 1 }).then(res => {
        if (res.data.success) {
          row.warehouseDeliveryArea = res.data.result.join()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    handleSelectionChange(val) {
      this.checkList = val
    },
    inventoryDetail(row) {
      // this.$router.push(`/Warehouse/InventoryDetail?id=${row.id}`)
      this.productSkuId = row.id
      this.getInventoryList()
    },
    getInventoryList() {
      let params = {
        InventoryId: 0,
        WarehouseLevel: this.searchInventory.WarehouseLevel,
        WarehouseName: this.searchInventory.WarehouseName,
        ProductSkuId: this.productSkuId,
        SkipCount: (this.searchInventory.PageIndex - 1) * this.searchInventory.PageSize,
        MaxResultCount: this.searchInventory.PageSize
      }
      GetAllInventoryItems(params).then((res) => {
        if (res.data.success) {
          this.inventoryTotal = res.data.result.totalCount;
          this.inventoryList = res.data.result.items;
          this.dialogInventory = true
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    search() {
      this.searchInventory.PageIndex = 1
      this.getInventoryList()
    },
    empty() {
      this.searchInventory = {
        WarehouseName: null,
        WarehouseLevel: null,
        PageIndex: 1,
        PageSize: 10
      }
      this.getInventoryList()
    },
    handleInventoryCurrentChange(val) {
      this.searchInventory.PageIndex = val
      this.getInventoryList()
    },
    handleInventorySizeChange(val) {
      this.searchInventory.PageSize = val
      this.getInventoryList()
    },
    addGoods() {
      this.$router.push(`/Product/AddEditSpu`)
    },
    batchDelete() {
      if (!this.checkList[0]) {
        return this.$message.error('请选择商品！')
      }
      let list = this.checkList.map(item => {
        return item.id
      }) || []
      ProductSkuDelete({ ids: list }).then(res => {
        if (res.data.success) {
          this.getSkuList()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    handleDetail(item, index, row) {
      this.$router.push(`/Product/SkuList/SkuInfo?id=${row.productId}`)
    },
    getBrandList(key) {
      let obj = {
        SkipCount: 0,
        MaxResultCount: 100,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.error.message);
            reject(res.data.error.message);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.searchData.BrandIds = item.id;
    },
    getProductNavTypeTree() {
      let that = this;
      CategoryGetTree({ parentId: 0 }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getSkuList();
    },
    handleSizeChange(e) {
      this.PageSize = e;
      this.getSkuList();
    },
    //获取规格列表
    getSkuList() {
      this.searchData.SkipCount = (this.PageIndex - 1) * this.PageSize
      this.searchData.MaxResultCount = this.PageSize
      this.listLoading = true;
      GetProductSkuList(this.searchData).then((res) => {
        if (res.data.success) {
          this.total = res.data.result.totalCount || 0;
          this.tableList = res.data.result.items || [];
        } else {
          this.$message.error(res.data.error.message)
        }
        setTimeout(() => {
          this.listLoading = false;
        }, 500)
      });
    },
    handleEdit(item, index, row) {
      this.$router.push(`/Product/AddEditSpu?id=${row.productId}`)
      // let { href } = this.$router.resolve({
      //   path: `/Product/ComManagement/EditProduct?id=${row.SpuId}`,
      // });
      // window.open(href, "_blank");
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    handleShelve(data) {
      ProductSkuShelves({id: data.id}).then(res => {
        if (res.data.success) {
          this.getSkuList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    searchFun() {
      this.PageIndex = 1;
      this.getSkuList();
    },
    resetFun() {
      this.searchData = {
        ProductSkuIds: null,
        ProductIds: null,
        ProductName: null,
        CategoryIds: null,
        BrandIds: null,
        ProductModel: null,
        BeginCreationTime: null,
        EndCreationTime: null,
        SkipCount: 0,
        MaxResultCount: 10,
        speCode: null,
        SourceId: ""
      }
      this.brandName = ''
      this.valueTime = []
      this.PageIndex = 1; //页码
      this.PageSize = 10; //页长
      this.getSkuList();
    },
    handlePicker(e) {
      if (e == null) {
        this.valueTime = []
        this.searchData.BeginCreationTime = null;
        this.searchData.EndCreationTime = null;
      } else {
        this.searchData.BeginCreationTime = e[0];
        this.searchData.EndCreationTime = e[1];
      }
    },
    handleDel(item, index, row) {
      ProductSkuDelete({ ids: [row.id] }).then(res => {
        if (res.data.success) {
          this.getSkuList()
          this.$message.success('删除成功！')
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    querySupplier(value) {
      SupplierGetAll({
        SkipCount: 0,
        MaxResultCount: 100,
        supplierName: value
      }).then(res => {
        if (res.data.success) {
          this.supplier = res.data.result.items
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/Product/AddEditSpu") {
      to.meta.keepAlive = true;
    } else {
      to.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
/* .el-input,
.el-select,
.el-cascader {
  width: 200px;
}

.el-form {
  background: #ebeef5;
  padding: 10px 10px 0 10px;
  margin-bottom: 20px;
}

section {
  padding: 20px;
} */
</style>
